import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Button,
  Row,
  Col
 } from 'react-bootstrap';
import Select from 'react-select';
import { notify } from 'actions';

class JNInitWizardPageFour extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      ht_fields : this.props.ht_fields,
      formatted_ht_fields : this.props.formatted_ht_fields,
      used_ht_fields : [
        'name',
        'email',
        'phone',
        'address.street',
        'address.city',
        'address.state',
        'address.zip',
        'address.country'
      ]
    };

    this.handleNewOptionCreate = this.handleNewOptionCreate.bind(this);
    this.handleSelectChange = this.handleSelectChange.bind(this);
    this.mapFieldType = this.mapFieldType.bind(this);
  }

  handleNewOptionCreate({ value }, jn_field) {
    const formatted_val = value.replace(/\s+/g, '_').toLowerCase();
    const found_field = this.state.formatted_ht_fields.find(f => {
      const formatted_field = f.label.replace(/\s+/g, '+_').toLowerCase();
      return formatted_val == formatted_field;
    });
    if(found_field) {
      this.props.notify({ message : 'New fields must be unique.' });
    }
    else {
      this.setState({
        formatted_ht_fields : [
          ...this.state.formatted_ht_fields,
          { value: formatted_val, label: value }
        ]
      }, this.handleSelectChange(jn_field, { value: formatted_val, label: value }));
    }
  }

  handleSelectChange(jn_field, val) {
    if(!val) {
      const { field_map } = this.props;
      const found_ht_field = this.state.formatted_ht_fields.find(f => f.label == field_map[jn_field.value]);
      this.setState({ used_ht_fields : this.state.used_ht_fields.filter(f => f != (found_ht_field || {}).value) });
      this.props.handleFieldMapChange({ [jn_field.field] : null });
    }
    else {
      this.setState({ used_ht_fields : [ ...this.state.used_ht_fields, val.value ] });
      this.props.handleFieldMapChange({ [jn_field.field] : val.label });
    }
    $('.jn-init-field-map-select').find('input').blur();
  }

  mapFieldType(jn_field) {
    const { type, options } = jn_field;

    switch(type) {
      case 'string':
        if(options && options.length > 0) {
          return 'select';
        }
        return 'text';
        break;
      case 'long': case 'double':
        return 'number';
        break;
      case 'boolean':
        return 'checkbox';
        break;
      case 'date':
        return 'date';
        break;
      default:
        throw new Error('Invalid Job Nimbus type passed to custom field');
    }
  }

  render() {
    const _self = this;
    const { field_map, jn_fields } = this.props;
    const formatted_ht_fields = this.state.formatted_ht_fields.filter(f => !this.state.used_ht_fields.includes(f.value));

    return (
      <div className='jn-init-wizard-pg-four-container'>
        <h4>Map Data Fields :</h4>
        <p><i>** Note : You can create new Hail Trace fields by entering text in the select field.</i></p>
        <hr className='dotted short' />
        {jn_fields.map((field, idx, arr) => {
          const field_options = formatted_ht_fields.filter(_f1 => {
            const arr_ref = arr;
            const current_ht_field = _self.state.ht_fields.find(_f2 => _f2.name == _f1.value);
            return current_ht_field ? _self.mapFieldType(field) == current_ht_field.type : true;
          });

          return (
            <div key={idx} className='mb-md'>
              <Row>
                <Col xs={6} md={6}>
                  <Select.Creatable
                    id={`jn-init-field-map-select-${idx}`}
                    className='jn-init-field-map-select'
                    options={field_options}
                    value={this.state.formatted_ht_fields.find(f => f.label == field_map[field.field])}
                    onChange={(val) => {this.handleSelectChange(field, val)}}
                    onNewOptionClick={e => this.handleNewOptionCreate(e, field)}
                  />
                </Col>
                <Col xs={1} md={1}><i className='fa fa-arrows-h' /></Col>
                <Col xs={5} md={5}>
                  <h5>{field.title}</h5>
                </Col>
              </Row>
            </div>
          );
        })}
      </div>
    );
  }
}

export default connect(null, { notify })(JNInitWizardPageFour);



// WEBPACK FOOTER //
// ./src/browser/components/settings/integrations/jobnimbus/jn-init-wizard-pg-four.js